<template>
    <div id="risk-analysis" class="container pt-5 pb-5">
        <h1 class="mb-3">Risicoscan</h1>
            <transition name="fade" mode="out-in">
                <card v-if="step === 1" key="1" >
                    <div slot="title">
                        <h2 class="mt-3 mb-3 title">Kies een risicoscan:</h2>
                    </div>
                    <div slot="content" class="mt-5 mb-5">
                        <button class="btn btn-lg btn-red mr-sm-3 mb-3" disabled>Een Object</button>
                        <button class="btn btn-lg btn-red ml-sm-3 mb-3" @click="next(2)">Een Evenement</button>
                    </div>
                </card>
                <card v-if="step === 2" title="Evenement" key="2" >
                    <div slot="title">
                        <h2 class="mt-3 mb-3 title ellipsis">Activiteitenprofiel</h2>
                    </div>
                    <div slot="content"  class="mt-5 mb-5 text-left">
                        <div class="form-group">
                            <label>Wat is de naam van het evenement?</label>
                            <input :class="['form-control', ($v.event.activity.name.$dirty) ? ($v.event.activity.name.$error) ?'is-invalid' : 'is-valid' : '']" type="text" v-model="event.activity.name" />
                        </div>
                        <div class="form-group">
                            <label>Wanneer vindt het evenement plaats?</label>
                            <input :class="['form-control', ($v.event.activity.date.$dirty) ? ($v.event.activity.date.$error) ?'is-invalid' : 'is-valid' : '']" type="date" v-model="event.activity.date" />
                        </div>
                        <hr class="mt-5 mb-5" />
                        <div class="form-group">
                            <label>Soort evenement?</label>
                            <select :class="['form-control', ($v.event.activity.type.$dirty) ? ($v.event.activity.type.$error) ?'is-invalid' : 'is-valid' : '']" v-model="event.activity.type" placeholder="Kies soort evenement...">
                                <option v-for="e in eventTypes" :key="e.name" :value="e">{{e.name}}</option>
                            </select>
                        </div>

                        <div class="form-group" v-show="!!event.activity.type && event.activity.type.name == 'Muziek Evenement'">
                            <label>Welk muziek evenement betreft het??</label>
                            <select :class="['form-control', ($v.event.activity.musicType.$dirty) ? ($v.event.activity.musicType.$error) ?'is-invalid' : 'is-valid' : '']" v-model="event.activity.musicType" placeholder="Kies soort muziekevenement...">
                                <option v-for="e in musicEventTypes" :key="e.name" :value="e">{{e.name}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Op welk moment vind het evenement plaats?</label>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" :class="['custom-control-input', ($v.event.activity.moment.day.$dirty) ? ($v.event.activity.moment.day.$error) ?'is-invalid' : 'is-valid' : '']" id="moment1" v-model="event.activity.moment.day">
                                <label class="custom-control-label" for="moment1">Overdag (06:00 - 18:00 uur)</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" :class="['custom-control-input', ($v.event.activity.moment.evening.$dirty) ? ($v.event.activity.moment.evening.$error) ?'is-invalid' : 'is-valid' : '']" id="moment2" v-model="event.activity.moment.evening">
                                <label class="custom-control-label" for="moment2">Avond (18:00 - 0:00 uur)</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" :class="['custom-control-input', ($v.event.activity.moment.night.$dirty) ? ($v.event.activity.moment.night.$error) ?'is-invalid' : 'is-valid' : '']" id="moment3" v-model="event.activity.moment.night">
                                <label class="custom-control-label" for="moment3">Nacht (0:00 - 06:00 uur)</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Duurt het evenement langer dan 24 uur?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.activity.longerThan24Hours.$dirty) ? ($v.event.activity.longerThan24Hours.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="longerThan24Hours" id="longerThan24Hours1" :value="true" v-model="event.activity.longerThan24Hours">
                                <label class="custom-control-label" for="longerThan24Hours1">
                                    Ja
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.activity.longerThan24Hours.$dirty) ? ($v.event.activity.longerThan24Hours.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="longerThan24Hours" id="longerThan24Hours2" :value="false" v-model="event.activity.longerThan24Hours">
                                <label class="custom-control-label" for="longerThan24Hours2">
                                    Nee
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Wordt er overnacht?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.activity.sleeping.$dirty) ? ($v.event.activity.sleeping.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="sleeping" id="sleeping1" value="Ja, bezoekers" v-model="event.activity.sleeping">
                                <label class="custom-control-label" for="sleeping1">
                                    Ja, bezoekers / toeschouwers / deelnemers
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.activity.sleeping.$dirty) ? ($v.event.activity.sleeping.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="sleeping" id="sleeping2" value="Ja, medewerkers van de organisatie" v-model="event.activity.sleeping">
                                <label class="custom-control-label" for="sleeping2">
                                    Ja, medewerkers van de organisatie
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.activity.sleeping.$dirty) ? ($v.event.activity.sleeping.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="sleeping" id="sleeping3" value="Nee" v-model="event.activity.sleeping">
                                <label class="custom-control-label" for="sleeping3">
                                    Nee
                                </label>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <label>Wat is de reputatie van de organisator?</label>
                            <select :class="['form-control', ($v.event.activity.reputation.$dirty) ? ($v.event.activity.reputation.$error) ?'is-invalid' : 'is-valid' : '']" v-model="event.activity.reputation">
                                <option value="Goed">Goede reputatie</option>
                                <option value="Redelijk">Redelijke reputatie</option>
                                <option value="Slecht">Slechte reputatie</option>
                                <option value="Onbekend">Onbekend</option>
                            </select>
                        </div>

                        <div class="row mt-5">
                            <div class="col-6 text-left">
                                <button @click="step = 1" class="btn btn-red">Vorige</button>
                            </div>
                            <div class="col-6 text-right">
                                <button @click="next(3, 'activity')" class="btn btn-red">Volgende</button>
                            </div>
                        </div>
                    </div>
                </card>
                <card v-if="step === 3" title="Evenement" key="3" >
                    <div slot="title">
                        <h2 class="mt-3 mb-3 title ellipsis">Publieksprofiel</h2>
                    </div>
                    <div slot="content"  class="mt-5 mb-5 text-left">
                       
                        <div class="form-group">
                            <label>Is er een (verhoogde) kans op een van de volgende specifieke groepen?</label>
                            <select :class="['form-control', ($v.event.public.groups.$dirty) ? ($v.event.public.groups.$error) ?'is-invalid' : 'is-valid' : '']" v-model="event.public.groups">
                                <option value="Activisten of radicalen">Activisten of radicalen</option>
                                <option value="Conflicterende- of rivaliserende groepen">Conflicterende- of rivaliserende groepen</option>
                                <option value="Perso(o)n(en) met bijzonder- of verhoogd risico">Perso(o)n(en) met bijzonder- of verhoogd risico</option>
                                <option value="Personen met een fysieke of verstandelijke handicap">Personen met een fysieke of verstandelijke handicap</option>
                                <option value="Overig publiek">Overig publiek</option>
                            </select>
                        </div>
                        
                        <div class="form-group">
                            <label>Wat is de belangrijkste leeftijdscategorie van het publiek?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.age.$dirty) ? ($v.event.public.age.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="age" id="age1" value="Alle leeftijden" v-model="event.public.age">
                                <label class="custom-control-label" for="age1">
                                    Alle leeftijden
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.age.$dirty) ? ($v.event.public.age.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="age" id="age2" value="0 - 18 jaar (zonder ouders)" v-model="event.public.age">
                                <label class="custom-control-label" for="age2">
                                    0 - 18 jaar (zonder ouders)
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.age.$dirty) ? ($v.event.public.age.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="age" id="age3" value="0 - 18 jaar (met ouders)" v-model="event.public.age">
                                <label class="custom-control-label" for="age3">
                                    0 - 18 jaar (met ouders)
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.age.$dirty) ? ($v.event.public.age.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="age" id="age4" value="18 - 35 jaar" v-model="event.public.age">
                                <label class="custom-control-label" for="age4">
                                    18 - 35 jaar
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.age.$dirty) ? ($v.event.public.age.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="age" id="age5" value="Ouder dan 65 jaar" v-model="event.public.age">
                                <label class="custom-control-label" for="age5">
                                    Ouder dan 65 jaar
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Hoeveel bedraagt het verwachte aantal deelnemers / bezoekers?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitors.$dirty) ? ($v.event.public.noOfVisitors.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitors" id="noOfVisitors1" value="< 2.500" v-model="event.public.noOfVisitors">
                                <label class="custom-control-label" for="noOfVisitors1">
                                    0 - 2.500
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitors.$dirty) ? ($v.event.public.noOfVisitors.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitors" id="noOfVisitors2" value="2.500 - 5.000" v-model="event.public.noOfVisitors">
                                <label class="custom-control-label" for="noOfVisitors2">
                                    2.500 - 5.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitors.$dirty) ? ($v.event.public.noOfVisitors.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitors" id="noOfVisitors3" value="5.000 - 10.000" v-model="event.public.noOfVisitors">
                                <label class="custom-control-label" for="noOfVisitors3">
                                    5.000 - 10.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitors.$dirty) ? ($v.event.public.noOfVisitors.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitors" id="noOfVisitors4" value="10.000 - 15.000" v-model="event.public.noOfVisitors">
                                <label class="custom-control-label" for="noOfVisitors4">
                                    10.000 - 15.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitors.$dirty) ? ($v.event.public.noOfVisitors.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitors" id="noOfVisitors5" value="15.000 - 20.000" v-model="event.public.noOfVisitors">
                                <label class="custom-control-label" for="noOfVisitors5">
                                    15.000 - 20.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitors.$dirty) ? ($v.event.public.noOfVisitors.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitors" id="noOfVisitors6" value="> 20.000" v-model="event.public.noOfVisitors">
                                <label class="custom-control-label" for="noOfVisitors6">
                                    Meer dan 20.000
                                </label>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <label>Hoeveel bezoekers zijn er op het piekmoment?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitorsPeak.$dirty) ? ($v.event.public.noOfVisitorsPeak.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitorsPeak" id="noOfVisitorsPeak1" value="< 2.500" v-model="event.public.noOfVisitorsPeak">
                                <label class="custom-control-label" for="noOfVisitorsPeak1">
                                    0 - 2.500
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitorsPeak.$dirty) ? ($v.event.public.noOfVisitorsPeak.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitorsPeak" id="noOfVisitorsPeak2" value="2.500 - 5.000" v-model="event.public.noOfVisitorsPeak">
                                <label class="custom-control-label" for="noOfVisitorsPeak2">
                                    2.500 - 5.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitorsPeak.$dirty) ? ($v.event.public.noOfVisitorsPeak.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitorsPeak" id="noOfVisitorsPeak3" value="5.000 - 10.000" v-model="event.public.noOfVisitorsPeak">
                                <label class="custom-control-label" for="noOfVisitorsPeak3">
                                    5.000 - 10.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitorsPeak.$dirty) ? ($v.event.public.noOfVisitorsPeak.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitorsPeak" id="noOfVisitorsPeak4" value="10.000 - 15.000" v-model="event.public.noOfVisitorsPeak">
                                <label class="custom-control-label" for="noOfVisitorsPeak4">
                                    10.000 - 15.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitorsPeak.$dirty) ? ($v.event.public.noOfVisitorsPeak.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitorsPeak" id="noOfVisitorsPeak5" value="15.000 - 20.000" v-model="event.public.noOfVisitorsPeak">
                                <label class="custom-control-label" for="noOfVisitorsPeak5">
                                    15.000 - 20.000
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.public.noOfVisitorsPeak.$dirty) ? ($v.event.public.noOfVisitorsPeak.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="noOfVisitorsPeak" id="noOfVisitorsPeak6" value="> 20.000" v-model="event.public.noOfVisitorsPeak">
                                <label class="custom-control-label" for="noOfVisitorsPeak6">
                                    Meer dan 20.000
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Is er aanwezigheid van alcohol / drugs en/of geneesmiddelen?</label>
                            <select :class="['form-control', ($v.event.public.drugs.$dirty) ? ($v.event.public.drugs.$error) ?'is-invalid' : 'is-valid' : '']" v-model="event.public.drugs">
                                <option value="Niet aanwezig">Niet aanwezig</option>
                                <option value="(Mogelijk) aanwezig, maar geen risicoverwachting">(Mogelijk) aanwezig, maar geen risicoverwachting</option>
                                <option value="Aanwezig met risicoverwachting">Aanwezig met risicoverwachting</option>
                            </select>
                        </div>

                        <div class="row mt-5">
                            <div class="col-6 text-left">
                                <button @click="step = 2" class="btn btn-red">Vorige</button>
                            </div>
                            <div class="col-6 text-right">
                                <button @click="next(4, 'public')"  class="btn btn-red">Volgende</button>
                            </div>
                        </div>
                    </div>
                </card>
                <card v-if="step === 4" title="Evenement" key="4" >
                    <div slot="title">
                        <h2 class="mt-3 mb-3 title">Ruimtelijkprofiel</h2>
                    </div>
                    <div slot="content"  class="mt-5 mb-5 text-left">
                       <div class="form-group">
                            <label>Zijn er publiekstromen tussen evenementenlocaties en podia?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.visitorStreams.$dirty) ? ($v.event.area.visitorStreams.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="visitorStreams" id="visitorStreams1" value="Statisch evenement op 1 locatie" v-model="event.area.visitorStreams">
                                <label class="custom-control-label" for="visitorStreams1">
                                    Statisch evenement op 1 locatie
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.visitorStreams.$dirty) ? ($v.event.area.visitorStreams.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="visitorStreams" id="visitorStreams2" value="Statisch evenement op 2 of meer locaties" v-model="event.area.visitorStreams">
                                <label class="custom-control-label" for="visitorStreams2">
                                    Statisch evenement op 2 of meer locaties
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.visitorStreams.$dirty) ? ($v.event.area.visitorStreams.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="visitorStreams" id="visitorStreams3" value="Dynamische evenement (verplaatsend)" v-model="event.area.visitorStreams">
                                <label class="custom-control-label" for="visitorStreams3">
                                    Dynamische evenement (verplaatsend)
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.visitorStreams.$dirty) ? ($v.event.area.visitorStreams.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="visitorStreams" id="visitorStreams4" value="Zowel dynamisch als statisch evenement" v-model="event.area.visitorStreams">
                                <label class="custom-control-label" for="visitorStreams4">
                                    Zowel dynamisch als statisch evenement
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Wat is het type locatie en terrein?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.location.$dirty) ? ($v.event.area.location.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="location" id="location1" value="Binnenlocatie / tent" v-model="event.area.location">
                                <label class="custom-control-label" for="location1">
                                    Binnenlocatie / tent
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.location.$dirty) ? ($v.event.area.location.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="location" id="location2" value="Buitenlocatie verhard" v-model="event.area.location">
                                <label class="custom-control-label" for="location2">
                                    Buitenlocatie verhard
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.location.$dirty) ? ($v.event.area.location.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="location" id="location3" value="Buitenlocatie onverhard" v-model="event.area.location">
                                <label class="custom-control-label" for="location3">
                                    Buitenlocatie onverhard
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.location.$dirty) ? ($v.event.area.location.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="location" id="location4" value="Buitenlocatie aan water" v-model="event.area.location">
                                <label class="custom-control-label" for="location4">
                                    Buitenlocatie aan water
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.location.$dirty) ? ($v.event.area.location.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="location" id="location5" value="Buitenlocatie op water" v-model="event.area.location">
                                <label class="custom-control-label" for="location5">
                                    Buitenlocatie op water
                                </label>
                            </div>
                        </div>      

                        <div class="form-group">
                            <label>Naar evenemententerrein: Hoe is de bereikbaarheid en toegankelijkheid?</label>
                            <select :class="['form-control', ($v.event.area.access.$dirty) ? ($v.event.area.access.$error) ?'is-invalid' : 'is-valid' : '']" v-model="event.area.access">
                                <option value="Goed / meerdere belangrijke toegangswegen">Goed / meerdere belangrijke toegangswegen</option>
                                <option value="Redelijk / slechts 1 belangrijke toegangsweg">Redelijk / slechts 1 belangrijke toegangsweg</option>
                                <option value="Matig / moeilijke doorgang en/of slechts 1 lokale toegangsweg">Matig / moeilijke doorgang en/of slechts 1 lokale toegangsweg</option>
                                <option value="Slecht / zeer moeilijke doorgang en/of slechts 1 onverharde toegangsweg">Slecht / zeer moeilijke doorgang en/of slechts 1 onverharde toegangsweg</option>
                             </select>
                        </div>      

                        <div class="form-group">
                            <label>Op het evenemententerrein: Hoe is de ontsluiting en toegankelijkheid?</label>
                            <select :class="['form-control', ($v.event.area.onSiteAccess.$dirty) ? ($v.event.area.onSiteAccess.$error) ?'is-invalid' : 'is-valid' : '']" v-model="event.area.onSiteAccess">
                                <option value="Goed / meerdere in- en uitgangen én adequate rijroutes op het terrein">Goed / meerdere in- en uitgangen én adequate rijroutes op het terrein</option>
                                <option value="Redelijk / 2 in- en uitgangn én adequate rijroutes op het terrein">Redelijk / 2 in- en uitgangn én adequate rijroutes op het terrein</option>
                                <option value="Matig / ingang tevens uitgang én adequate rijroutes op het terrein">Matig / ingang tevens uitgang én adequate rijroutes op het terrein</option>
                                <option value="Matig / meerdere in- en uitgangen én geen adequate rijroutes op het terrein">Matig / meerdere in- en uitgangen én geen adequate rijroutes op het terrein</option>
                                <option value="Slecht / 2 in- en uitgangen én geen adequate rijroute op het terrein">Slecht / 2 in- en uitgangen én geen adequate rijroute op het terrein</option>
                                <option value="Slecht / ingang tevens uitgang én geen adequate rijroute op het terrein">Slecht / ingang tevens uitgang én geen adequate rijroute op het terrein</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Zijn er gevolgen voor het lokale of regionale wegennet (b.v. afsluitingen) en/of het OV?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.publicRoad.$dirty) ? ($v.event.area.publicRoad.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="publicRoad" id="publicRoad1" value="Lokaal" v-model="event.area.publicRoad">
                                <label class="custom-control-label" for="publicRoad1">
                                    Lokaal
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.publicRoad.$dirty) ? ($v.event.area.publicRoad.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="publicRoad" id="publicRoad2" value="Regionaal of groter" v-model="event.area.publicRoad">
                                <label class="custom-control-label" for="publicRoad2">
                                    Regionaal of groter
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.publicRoad.$dirty) ? ($v.event.area.publicRoad.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="publicRoad" id="publicRoad3" value="Niet van toepassing" v-model="event.area.publicRoad">
                                <label class="custom-control-label" for="publicRoad3">
                                    Niet van toepassing
                                </label>
                            </div>
                        </div> 

                        <div class="form-group">
                            <label>Is er sprake van een risico-object op of aan het evenemententerrein?</label>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.riskObject.$dirty) ? ($v.event.area.riskObject.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="riskObject" id="riskObject1" :value="true" v-model="event.area.riskObject">
                                <label class="custom-control-label" for="riskObject1">
                                    Ja
                                </label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input :class="['custom-control-input', ($v.event.area.riskObject.$dirty) ? ($v.event.area.riskObject.$error) ?'is-invalid' : 'is-valid' : '']" type="radio" name="riskObject" id="riskObject2" :value="false" v-model="event.area.riskObject">
                                <label class="custom-control-label" for="riskObject2">
                                    Nee
                                </label>
                            </div>
                        </div>  

                        <div class="row mt-5">
                            <div class="col-6 text-left">
                                <button @click="step = 3" class="btn btn-red">Vorige</button>
                            </div>
                            <div class="col-6 text-right">
                                <button @click="next(99, 'area')" class="btn btn-red">Afronden</button>
                            </div>
                        </div>
                    </div>
                </card>
                
                <card v-if="step === 99" title="Evenement" key="99" >
                    <div slot="title">
                        <h2 class="mt-3 mb-3 title">Versturen</h2>
                        <p>U ontvangt van ons het rapport van de risicoscan per email</p>
                    </div>
                    <div slot="content"  class="mt-5 mb-5 text-left">
                        <div class="row">
                            <div class="col-md-6 offset-md-3">
                                <div class="alert alert-success" v-if="success">
                                    <strong>Ontvangen!</strong> Bedankt, we sturen u zo spoedig mogelijk het rapport toe.
                                </div>
                                <div class="text-center" v-if="isLoading">
                                    <loader width="5rem"></loader>
                                </div>
                                <form @submit.prevent="send">
                                    <div class="form-group">
                                        <input :class="['form-control', ($v.form.name.$dirty) ? ($v.form.name.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Uw naam..." v-model="form.name" name="name" :disabled="isLoading || success" />
                                    </div>
                                    <div class="form-group">
                                        <input :class="['form-control', ($v.form.email.$dirty) ? ($v.form.email.$error) ?'is-invalid' : 'is-valid' : '']" type="email" placeholder="Uw email..." v-model="form.email" name="email" :disabled="isLoading || success" />
                                    </div>
                                    <div class="form-group">
                                        <input :class="['form-control', ($v.form.phone.$dirty) ? ($v.form.phone.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="Uw telefoonnummer..." v-model="form.phone" name="phone" :disabled="isLoading || success" />
                                    </div>
                                    <div class="form-group">
                                        <textarea class="form-control" placeholder="Opmerkingen..." v-model="form.comments" name="comments" :disabled="isLoading || success"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-red btn-lg btn-wide text-center" :disabled="isLoading || success">Versturen</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </card>
            </transition>
    </div>
</template>

<script>
const mobile = helpers.regex('mobile', /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7}|((\\+31|0|0031)6)[-]{1}[1-9]{1}[0-9]{7})$/);
const landline = helpers.regex('landline', /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/);

const greaterThanToday = (value, vm) => new Date(value) > new Date();
const isIE = () => {
    const ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

    return is_ie; 
}
const scrollToTop = () => {
    setTimeout(() => {
        if(isIE())
        {
            window.scroll(0, 0);
        } else {
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
            })
        }
    },1);
}
import { validationMixin } from 'vuelidate'
import { required, requiredIf, or, email, helpers } from 'vuelidate/lib/validators'
import Card from '@/components/Card'
import Loader from '@/components/Loader'

export default {
    mixins: [validationMixin],
    components: {
        Card,
        Loader
    },
    data() {
        return {
            isLoading: false,
            success: false,
            step: 1,
            eventTypes: [
                {
                    name: "Beurs of Show",
                    score: 0
                },
                {
                    name: "Markt of Braderie",
                    score: 0
                },
                {
                    name: "Wandelmars",
                    score: 0
                },
                {
                    name: "Demonstratie",
                    score: 1
                },
                {
                    name: "Kermis",
                    score: 1
                },
                {
                    name: "Lasershow",
                    score: 1
                },
                {
                    name: "Muziek Evenement",
                    score: 1
                },
                {
                    name: "Tourrit (Fiets, skeelers, fiets, motor, auto)",
                    score: 1
                },
                {
                    name: "Auto- of Motorsport wedstrijd",
                    score: 3
                },
                {
                    name: "Circus",
                    score: 3
                },
                {
                    name: "Corso of Optocht",
                    score: 3
                },
                {
                    name: "Culinair Evenement",
                    score: 3
                },
                {
                    name: "Extreme Sport",
                    score: 3
                },
                {
                    name: "Festival, tent- of schuurfeest",
                    score: 3
                },
                {
                    name: "Wieler- of Hardloopwedstrijd",
                    score: 3
                },
                {
                    name: "Marathon",
                    score: 5
                },
                {
                    name: "Vliegshow",
                    score: 5
                },
                {
                    name: "Vuurwerkevenement",
                    score: 5
                }
            ],
            musicEventTypes: [
                {
                    name: "Pop / Rock",
                    score: 1
                },
                {
                    name: "Nederlandstalig / levenslied",
                    score: 1
                },
                {
                    name: "Metal / Hardrock",
                    score: 3
                },
                {
                    name: "Urban / HipHop / R&B",
                    score: 3
                },
                {
                    name: "House / Dance",
                    score: 5
                },
                {
                    name: "Andere soort (bijv. Jazz of Klassiek)",
                    score: 0
                },
                {
                    name: "Niet van toepassing",
                    score: 0
                }
            ],
            form: {
                name: null,
                email: null,
                phone: null,
                comments: null,
                referer: 'Veiligheidsteam | Risicoscan',
                data: null
            },
            event: {
                activity: {
                    name: null,
                    date: null,
                    type: null,
                    musicType: null,
                    moment: 
                    {
                        day: false,
                        evening: false,
                        night: false
                    },
                    longerThan24Hours: false,
                    sleeping: "Nee",
                    reputation: "Goed"
                },
                public: {
                    groups: null,
                    age: null,
                    noOfVisitors: null,
                    noOfVisitorsPeak: null,
                    drugs: null
                },
                area: {
                    visitorStreams: null,
                    location: null,
                    access: null,
                    onSiteAccess: null,
                    publicRoad: null
                }
            },
            object: {

            }
        }
    },
    validations: {
        event: {
            activity: {
                name: {
                    required,
                },
                date: {
                    required,
                    greaterThanToday
                },
                type: {
                    required
                },
                musicType: {
                    requiredIf: requiredIf((vm) => {
                        return !!vm.type && vm.type.name == "Muziek Evenement"
                    })
                },
                moment: {
                    day: {
                        mustBeTrue (value, vm) {
                            return value || vm.evening || vm.night
                        }
                    },
                    evening: {
                        mustBeTrue (value, vm) {
                            return value || vm.day || vm.night
                        }
                    },
                    night: {
                        mustBeTrue (value, vm) {
                            return value || vm.evening || vm.day
                        }
                    }
                },
                longerThan24Hours: {
                    required,
                },
                sleeping: {
                    required,
                },
                reputation: {
                    required
                }
            },
            public: {
                groups: {
                    required
                },
                age: {
                    required
                },
                noOfVisitors: {
                    required
                },
                noOfVisitorsPeak: {
                    required
                },
                drugs: {
                    required
                }
            },
            area: {
                visitorStreams: {
                    required
                },
                location: {
                    required
                },
                access: {
                    required
                },
                onSiteAccess: {
                    required
                },
                publicRoad: {
                    required
                },
                riskObject: {
                    required
                }
            }
        },
        form: {
            name: {
                required
            },
            email: {
                required,
                email
            },
            phone: {
                or: or(landline, mobile)
            }
        }
    },
    methods: {
        next(step, validate) {
            if(!!validate)
            {
                if(!!this.$v.event[validate])
                {
                    this.$v.event[validate].$touch();
                    if(this.$v.event[validate].$invalid)
                        return;
                }
            }

            if(!!step)
            {
                this.step = step;
                window.location.hash = "#" + step;
            } else {
                this.step++;
            }
            scrollToTop();
        },
        prev() {
            this.step--;
        },
        send() {
            this.$v.form.$touch();

            if(this.$v.form.$invalid)
                return;

            this.isLoading = true;
            this.form.data = JSON.stringify(this.event)
            this.$http.post("api/Form", this.form).then((res) => {
                this.isLoading = false;
                this.success = true;
            }).catch(() => {
                this.success = false;
                this.isLoading = false;
            })
        }
    }
}
</script>

<style scoped>

.fade-enter-active, .fade-leave-active {
   transition: opacity .5s;
 }
 .fade-enter, .fade-leave-to, .fade-leave-active {
   opacity: 0;
 }

label:not(.custom-control-label) {
    font-weight: 700
}
 
</style>